<script lang="ts" module>
    export const route = "/closing-page";
    export const sessionRequired = false;
</script>

<script lang="ts">
    window.close();
</script>
